import React from 'react';

const PrivacyPolicy: React.FC = () => {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <h1>Privacy Policy</h1>
        <div className="legal-content">
          <h2>1. Information We Collect</h2>
          <p>We collect information you provide directly to us, such as when you create an account, subscribe to our service, or contact us for support. This may include:</p>
          <ul>
            <li>Personal information such as name, email address, and contact details</li>
            <li>Account credentials and authentication information</li>
            <li>Payment and billing information (processed securely through third-party providers)</li>
            <li>Communications you send to us</li>
            <li>Usage data and analytics about how you interact with our service</li>
            <li>Device information including IP address, browser type, and operating system</li>
          </ul>
          
          <h2>2. How We Collect Information</h2>
          <p>We collect information through various methods:</p>
          <ul>
            <li>Information you provide directly through forms, account registration, and communications</li>
            <li>Automated collection through cookies, web beacons, and similar technologies</li>
            <li>Third-party integrations and APIs that you authorize</li>
            <li>Analytics services that help us understand service usage</li>
          </ul>
          
          <h2>3. How We Use Your Information</h2>
          <p>We use the information we collect to:</p>
          <ul>
            <li>Provide, maintain, and improve our services</li>
            <li>Process transactions and send related information</li>
            <li>Send technical notices, updates, security alerts, and support messages</li>
            <li>Respond to your comments, questions, and customer service requests</li>
            <li>Communicate about products, services, offers, and events</li>
            <li>Monitor and analyze trends, usage, and activities</li>
            <li>Detect, investigate, and prevent fraudulent or unauthorized activities</li>
            <li>Comply with legal obligations and enforce our agreements</li>
          </ul>
          
          <h2>4. Information Sharing and Disclosure</h2>
          <p>We do not sell, trade, or otherwise transfer your personal information to third parties without your consent, except in the following circumstances:</p>
          <ul>
            <li>With service providers who assist us in operating our platform</li>
            <li>When required by law, court order, or government regulation</li>
            <li>To protect our rights, property, or safety, or that of our users</li>
            <li>In connection with a merger, acquisition, or sale of assets</li>
            <li>With your explicit consent for specific sharing</li>
          </ul>
          
          <h2>5. Data Security and Protection</h2>
          <p>We implement appropriate technical and organizational security measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. These measures include:</p>
          <ul>
            <li>Encryption of data in transit and at rest</li>
            <li>Regular security assessments and monitoring</li>
            <li>Access controls and employee training</li>
            <li>Secure hosting and infrastructure</li>
          </ul>
          <p>However, no method of transmission over the internet or electronic storage is 100% secure, and we cannot guarantee absolute security.</p>
          
          <h2>6. Cookies and Tracking Technologies</h2>
          <p>We use cookies, web beacons, and similar tracking technologies to enhance your experience and analyze usage patterns. You can control cookie preferences through your browser settings, though this may affect service functionality.</p>
          
          <h2>7. Data Retention</h2>
          <p>We retain your personal information for as long as necessary to provide our services, comply with legal obligations, resolve disputes, and enforce our agreements. When no longer needed, we securely delete or anonymize your information.</p>
          
          <h2>8. Your Rights and Choices</h2>
          <p>Depending on your location, you may have certain rights regarding your personal information, including:</p>
          <ul>
            <li>Access to and copies of your personal information</li>
            <li>Correction of inaccurate or incomplete information</li>
            <li>Deletion of your personal information in certain circumstances</li>
            <li>Restriction or objection to certain processing activities</li>
            <li>Data portability in machine-readable format</li>
            <li>Withdrawal of consent where processing is based on consent</li>
          </ul>
          
          <h2>9. International Data Transfers</h2>
          <p>Your information may be transferred to and processed in countries other than your own. We ensure appropriate safeguards are in place to protect your information in accordance with applicable privacy laws.</p>
          
          <h2>10. Third-Party Services and Links</h2>
          <p>Our service may contain links to third-party websites or integrate with third-party services. We are not responsible for the privacy practices of these third parties. We encourage you to read their privacy policies.</p>
          
          <h2>11. Children's Privacy</h2>
          <p>Our service is not intended for children under 13 (or the applicable age of consent in your jurisdiction). We do not knowingly collect personal information from children. If we become aware of such collection, we will take steps to delete the information.</p>
          
          <h2>12. Changes to This Privacy Policy</h2>
          <p>We may update this Privacy Policy from time to time to reflect changes in our practices or applicable laws. We will notify you of any material changes by posting the new policy on this page and updating the "Last updated" date. Continued use of our service constitutes acceptance of the updated policy.</p>
          
          <h2>13. Contact Us</h2>
          <p>If you have any questions about this Privacy Policy or wish to exercise your rights, please contact us through our support channels or via email: support@prediedge.com. We will respond to your requests in accordance with applicable privacy laws.</p>
          
          <p className="last-updated">Last updated: November 2025</p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy; 